import { useState } from 'react';
import { Element } from 'slate';
import { ReactEditor, useSlateStatic } from 'slate-react';
import { findPrecedingHeadingText } from 'slate/functions';
import { AiApplicationModal } from './AiApplicationModal';
import { usePermissions } from 'app/api/permission-queries';

interface SelectedCell {
  row: number;
  col: number;
  value: string;
  isNumeric: boolean;
}

interface AiSuggestTagsProps {
  element?: Element;
  referenceDataSuperId?: string;
  documentSuperId?: number | string;
  selectedCells?: SelectedCell[];
}

export const AiSuggestTags = ({ element, referenceDataSuperId, documentSuperId, selectedCells }: AiSuggestTagsProps) => {
  const [open, setOpen] = useState(false);
  const [tableTitle, setTableTitle] = useState('');
  const editor = useSlateStatic();

  const { documentPermissions } = usePermissions(documentSuperId as number | string);
  const canEditTags = documentPermissions.includes('TAG_EDITOR') || documentPermissions.includes('TAG_ADMIN');

  const docId = Number(documentSuperId);

  if (!canEditTags || !referenceDataSuperId || !selectedCells?.length) {
    return null;
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!Number.isFinite(docId)) return;
    try {
      setTableTitle(element ? findPrecedingHeadingText(editor, ReactEditor.findPath(editor, element)) : '');
    } catch {
      setTableTitle('');
    }
    setOpen(true);
  };

  return (
    <>
      <button type="button" className="icon-button icon-button__default" aria-label="ai-suggest-tags" onMouseDown={handleClick}>
        <i className="fa-solid fa-lg fa-wand-magic-sparkles" />
      </button>
      {open && (
        <AiApplicationModal
          show={open}
          onClose={() => setOpen(false)}
          referenceDataSuperId={referenceDataSuperId}
          documentSuperId={docId}
          tableTitle={tableTitle}
        />
      )}
    </>
  );
};
